module.exports = __webpack_public_path__ + "static/media/paid-search-illustr-1.0a17cd5a.png";